export default "__VITE_ASSET__504ad766__"